<template>
  <span>
    <ViewBar :prominent="false">
      <template #default>
        <v-toolbar color="grey lighten-3" flat dense text>
          <v-progress-linear v-if="loading" :active="loading" rounded indeterminate></v-progress-linear>
          <span v-else class="v-toolbar__title">{{ $t('app.label.campaign') }}</span>
          <v-spacer></v-spacer>
          <v-tooltip v-if="defaultCampaign && !editionMode" bottom open-delay="600">
            <template v-slot:activator="{ on }">
              <v-btn
                id="btn_edit_campaign"
                v-on="on"
                icon
                @click="startEdition"
                color="primary"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('campaigns.label.edit')}}</span>
          </v-tooltip>
          <v-tooltip v-if="editionMode" bottom open-delay="600">
            <template v-slot:activator="{ on }">
              <v-btn
                id="btn_cancel_campaign"
                v-on="on"
                icon
                @click="cancelEdition"
                color="primary"
              >
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('campaigns.label.cancel')}}</span>
          </v-tooltip>
          <v-tooltip v-if="editionMode" bottom open-delay="600">
            <template v-slot:activator="{ on }">
              <v-btn
                id="btn_save_campaign"
                v-on="on"
                icon
                @click="saveEdition"
                color="primary"
              >
                <v-icon>mdi-check</v-icon>
              </v-btn>
            </template>
            <span>{{$t('campaigns.label.save')}}</span>
          </v-tooltip>
        </v-toolbar>
      </template>
    </ViewBar>
    <ViewBarVerticalPadding
      height="60px"
      :prominent="false" 
    ></ViewBarVerticalPadding>
    <div v-if="loading">
    </div>
    <div v-else-if="defaultCampaign">
      <v-tabs fixed-tabs slot="extension" v-model="selectedTab" :change="changed()">
        <v-tab
          v-for="{key, label} in configurationTabs"
          :key="key"
          :href="`#tab-${key}`"
          :id="`tab-link-${key}`"
        >{{ $t(label) }}</v-tab>
        <v-tab-item
          v-for="{key, label, component} in configurationTabs"
          :value="`tab-${key}`"
          :key="key"
        >
          <component 
            v-bind:is="component" 
            :editionMode="editionMode" 
            :users="users"
            :campaign="vueDefaultCampain"
            :availableReconciliationUsers="availableReconciliationUsers"
            @change="onChange"
            @action="onAction"
          ></component>
        </v-tab-item>
      </v-tabs>
    </div>
    <div v-else>
      <a @click="createDefaultCampaign">{{ $t('campaigns.label.createCampaign') }}</a>
    </div>
  </span>
</template>

<script>
import CampaignSetup from "../components/campaign/CampaignSetup";
import CampaignRun from "../components/campaign/CampaignRun";
import CampaignMessages from "../components/campaign/CampaignMessages";
import ViewBar from "../components/viewbar/ViewBar";
import ViewBarVerticalPadding from "../components/viewbar/ViewBarVerticalPadding";
import { mapActions, mapState } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import {JSONPath} from 'jsonpath-plus';
import moment from "moment";

export default {
  components: {
    ViewBar,
    ViewBarVerticalPadding,
    CampaignSetup,
    CampaignMessages,
    CampaignRun,
  },
  data() {
    return {
      selectedTab: null,
      loading: true,
      editionMode: false,
      changedPaths: [],
      users: [],
      availableReconciliationUsers: [],
      vueDefaultCampain: {
        id: "",
        label: "",
        emailNotifications: {
          enabled: false,
          notifiedUsers: [],
        },
        welcomeMessages: [],
        overviewMessages: [],
        stopMessages: [],
        userGroups: [],
        sessionModes: [],
        sessions: [],
        userSessions: [],
      }
    };
  },
  mounted() {
    this.fetchCampaignsWithLoading()
    let selectedTab = this.$route.params.selectedTab;
    if (selectedTab) {
      this.selectedTab = `tab-${selectedTab}`;
    } else {
      this.selectedTab = "tab-setup"
    }
  },
  watch: {
    '$route.params.selectedTab': function (selectedTab) {
      if (selectedTab) {
        this.selectedTab = `tab-${selectedTab}`;
      }
    },
    "userSessionStateChangeEvent": function(event) {
      if (event) {
        const {campaignId, userSessionId, newState} = event;
        if (this.vueDefaultCampain.id == campaignId) {
          for (const userSession of this.vueDefaultCampain.userSessions) {
            if (userSession.id == userSessionId) {
              userSession.state = newState
            }
          }
        }
      }
    },
    "defaultCampaign": function(campaign) {
      this.changedPaths = [];
      this.vueDefaultCampain.emailNotifications.notifiedUsers.splice(0, this.vueDefaultCampain.emailNotifications.notifiedUsers.length)
      this.vueDefaultCampain.sessions.splice(0, this.vueDefaultCampain.sessions.length)
      this.vueDefaultCampain.userSessions.splice(0, this.vueDefaultCampain.userSessions.length)
      this.vueDefaultCampain.userGroups.splice(0, this.vueDefaultCampain.userGroups.length)
      this.vueDefaultCampain.sessionModes.splice(0, this.vueDefaultCampain.sessionModes.length)
      this.vueDefaultCampain.welcomeMessages.splice(0, this.vueDefaultCampain.welcomeMessages.length)
      this.vueDefaultCampain.overviewMessages.splice(0, this.vueDefaultCampain.overviewMessages.length)
      this.vueDefaultCampain.stopMessages.splice(0, this.vueDefaultCampain.stopMessages.length)
      if (campaign) {
        this.vueDefaultCampain.id = campaign.id
        this.vueDefaultCampain.label = campaign.label
        for (let field of ["welcomeMessages", "overviewMessages", "stopMessages"]) {
          const messageArray = campaign[field]
          if (messageArray) {
            for (let message of messageArray) {
              const localized = message.localized;
              const newLocalized = [];
              const vueMessage = {uuid: uuidv4(), id: message.id, localized: newLocalized, existing: true }
              for (const [key, value] of Object.entries(localized)) {
                newLocalized.push({uuid: uuidv4(), language: key, title: value.title, body: value.body, existing: true })
              }
              this.vueDefaultCampain[field].push(vueMessage)
            }
          }
        }
        const emailNotifications = campaign.emailNotifications
        if (emailNotifications) {
          this.vueDefaultCampain.emailNotifications.enabled = emailNotifications.enabled
          this.vueDefaultCampain.emailNotifications.notifiedUsers = [...emailNotifications.notifiedUsers]
        }
        const userGroups = campaign.userGroups
        if (userGroups) {
            for (let userGroup of userGroups) {
              const vueUserGroup = {
                uuid: uuidv4(), 
                ...userGroup, 
                users: [...userGroup.users], // to make sure we have another vue-reactive array instance
                existing: true,
              }
              this.vueDefaultCampain.userGroups.push(vueUserGroup)
            }
        }
        const sessionModes = campaign.sessionModes
        if (sessionModes) {
            for (let sessionMode of sessionModes) {
              const vueSessionMode = {
                uuid: uuidv4(), 
                ...sessionMode,
                openFunctionalRoles: [...sessionMode.openFunctionalRoles],  // to make sure we have another vue-reactive array instance
                startedFunctionalRoles: [...sessionMode.startedFunctionalRoles],  // to make sure we have another vue-reactive array instance
                existing: true,
              }
              this.vueDefaultCampain.sessionModes.push(vueSessionMode)
            }
        }
        const sessions = campaign.sessions
        if (sessions) {
            for (let session of sessions) {
              const duration = moment.duration(session.duration*1000)
              let hours = duration.hours().toString().padStart(2, "0")
              let minutes = duration.minutes().toString().padStart(2, "0")
              let seconds = duration.seconds().toString().padStart(2, "0")
              const vueSession = {
                uuid: uuidv4(), 
                ...session, 
                splitSize: Math.round(100 * session.splitSize),
                duration: `${hours}:${minutes}:${seconds}`,
                existing: true
              }
              this.vueDefaultCampain.sessions.push(vueSession)
            }
        }
        const userSessions = campaign.userSessions
        if (userSessions) {
            for (let {id, username, sessionModeId, sessionId, state} of userSessions) {
              const vueUserSession = {
                uuid: uuidv4(),
                id,
                username, 
                sessionId,
                sessionModeId,
                state,
                existing: true,
                exporting: false,
              }
              this.vueDefaultCampain.userSessions.push(vueUserSession)
            }
        }
      } else {
        this.vueDefaultCampain.id = ""
        this.vueDefaultCampain.label = ""
      }
    }
  },
  computed: {
  // ...mapGetters("auth", ["canWriteAnyGroup"]),
    ...mapState("campaigns", ["defaultCampaign", "userSessionStateChangeEvent"]),
    configurationTabs() {
      const result = []
      if (this.setupTabVisible) {
        result.push({
          key: "setup",
          label: "campaigns.label.setup",
          component: "CampaignSetup"
        })
      }
      result.push({
        key: "messages",
        label: "campaigns.label.messages",
        component: "CampaignMessages"
      })
      if (this.runTabVisible) {
        result.push({
          key: "run",
          label: "campaigns.label.run",
          component: "CampaignRun"
        })
      }
      return result;
    },
    setupTabVisible() {
      // make sure user sessions are not being edited
      return !this.changedPaths.find(c => c.includes("$.userSessions"));
    },
    runTabVisible() {
      // make sure there is no "newly created thing in sessions, groups, modes"
      // make sure none of them is currently being edited
      // and make sure there is at least one of each
      return !this.vueDefaultCampain.userGroups.find(it => !it.existing) &&  
        !this.vueDefaultCampain.sessionModes.find(it => !it.existing) &&
        !this.vueDefaultCampain.sessions.find(it => !it.existing) && 
        !this.changedPaths.find(c => c.includes("$.userGroups")) &&
        !this.changedPaths.find(c => c.includes("$.sessionModes")) &&
        !this.changedPaths.find(c => c.includes("$.sessionModes")) &&
        this.vueDefaultCampain.userGroups.length != 0 &&
        this.vueDefaultCampain.sessionModes.length != 0 &&
        this.vueDefaultCampain.sessions.length != 0;
    },
  },
  methods: {
    ...mapActions("campaigns", ["fetchCampaigns", "createDefaultCampaign", "updateCampaign", "campaignUserSessionAction"]),
    changed() {
      if (this.selectedTab && this.selectedTab != `tab-${this.$route.params.selectedTab}`) {
        this.$router.push({ name: 'campaignByParams', params: { selectedTab:this.selectedTab.substring(4) }})
      }
    },
    async fetchCampaignsWithLoading() {
      this.editionMode = false
      this.changedPaths = []
      this.loading = true;
      try {
        const users = await this.$store._getUsers() // { groupName=null }
        for (const user of users) {
          this.users.push(user)
        }
        await this.fetchCampaigns()
        this.computeAvailableReconciliationUsers();
      } finally {
        this.loading = false;
      }
    },
    computeAvailableReconciliationUsers() {
      this.availableReconciliationUsers.splice(0, this.availableReconciliationUsers.length);
      for (const user of this.users) {
        if (!this.vueDefaultCampain.userSessions.find(userSession => userSession.username == user.username) 
          && !this.vueDefaultCampain.sessions.find(session => session.reconciliationUsername == user.username)) {
          this.availableReconciliationUsers.push(user)
        }
      }
    },
    startEdition() {
      this.editionMode = true
    },
    cancelEdition() {
      this.fetchCampaignsWithLoading()
    },
    onChange(event) {
      const {jsonpath, op} = event;
      const [result] = JSONPath({path: jsonpath, json: this.vueDefaultCampain});
      this.changedPaths.push(jsonpath)
      if (op.name == "patch") {
        for (let [key, value] of Object.entries(op.value)) {
          if (value != null) {
            result[key] = value
          } else {
            delete result[key]
          }
          if (key == "reconciliationUsername") {
            // there seem to be a reactivity issue
            // a computed does not work as expected
            // probably because in this particular case, a deeply nested object (a session)
            // will be modified and it will not trigger a local change
            this.computeAvailableReconciliationUsers();
          }
        }
      } else if (op.name == "add") {
        result.push(op.value)
      } else if (op.name == "remove") {
        result.splice(op.value, 1)
      } else if (op.name == "move") {
        const {oldIndex, newIndex} = op.value;
        const item = result[oldIndex]
        result.splice(oldIndex, 1)
        result.splice(newIndex, 0, item)
      } else {
        console.error("unsupported operation " + op.name)
      }
    },
    async saveEdition() {
      const patch = {};
      // let userSessions = [];
      for (const [key, value] of Object.entries(this.vueDefaultCampain)) {
        if (key == "welcomeMessages" || key == "overviewMessages" || key == "stopMessages") {
          if (this.changedPaths.findIndex(c => c.includes(key)) != -1) {
            const messages = []
            patch[key] = messages
            for (const vueMessage of value) {
              const message = vueMessage.id ? {id: vueMessage.id} : {}
              messages.push(message)
              const localized = {}
              message.localized = localized
              for (const vueLocalized of vueMessage.localized) {
                localized[vueLocalized.language] = {title: vueLocalized.title, body: vueLocalized.body}
              }
            }
          }
        } else if (key == "emailNotifications") {
          if (this.changedPaths.findIndex(c => c.includes("$.emailNotifications")) != -1) {
            // eslint-disable-next-line no-unused-vars
            patch.emailNotifications = this.vueDefaultCampain.emailNotifications
          }
        } else if (key == "userGroups") {
          if (this.changedPaths.findIndex(c => c.includes("$.userGroups")) != -1) {
            // eslint-disable-next-line no-unused-vars
            patch.userGroups = this.vueDefaultCampain.userGroups.map(({uuid, existing=false, ...rest}) => rest)
          }
        } else if (key == "sessionModes") {
          if (this.changedPaths.findIndex(c => c.includes("$.sessionModes")) != -1) {
            // eslint-disable-next-line no-unused-vars
            patch.sessionModes = this.vueDefaultCampain.sessionModes.map(({uuid, existing=false, ...rest}) => rest)
          }
        } else if (key == "sessions") {
          if (this.changedPaths.findIndex(c => c.includes("$.sessions")) != -1) {
            const rewriteSession = function(session) {
              session.duration = moment.duration(session.duration).asSeconds()
              session.splitSize = session.splitSize / 100
              delete session.userSessions
              delete session.open
              delete session.existing
              return session
            }
            // eslint-disable-next-line no-unused-vars
            patch.sessions = this.vueDefaultCampain.sessions.map(({uuid, ...rest}) => rewriteSession(rest))
          }
        } else if (key == "userSessions") {
          if (this.changedPaths.findIndex(c => c.includes("$.userSessions")) != -1) {
            // eslint-disable-next-line no-unused-vars
            patch.userSessions = this.vueDefaultCampain.userSessions.map(({existing=false, exporting=false, uuid, state, ...rest}) => state == "JUST_CREATED" ? rest : {state, ...rest})
          }
        } else if (this.changedPaths.indexOf("$") != -1) {
          if (typeof value == "string") {
            if (key != "id") {
              patch[key] = value;
            }
          } else {
            throw new Error("not implemented");
          }
        }
      }
      if (Object.keys(patch).length != 0) {
        await this.updateCampaign({id: this.vueDefaultCampain.id, patch})
      }
      // if (userSessions.length != 0) {
      //   await this.createCampaignUserSessions({id: this.vueDefaultCampain.id, userSessions})
      // }
      await this.fetchCampaignsWithLoading()
    },
    async onAction({name, value}) {
      this.loading = true
      try {
        if (name == "_user_session_actions") {
          for (let action of value) {
            await this.campaignUserSessionAction(action)
          }
          await this.fetchCampaignsWithLoading()
        }
      } finally {
        this.loading = false
      }
    },

  }
};
</script>
